import { render, staticRenderFns } from "./assign-contact.vue?vue&type=template&id=26678743&scoped=true"
import script from "./assign-contact.vue?vue&type=script&lang=js"
export * from "./assign-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26678743",
  null
  
)

export default component.exports